export default __webpack_public_path__ + "static/ac1-7ae464f308fad26f130255941e0fd456.png";